import Vue from 'vue'
import { Button, Input, Loading, Message } from 'element-ui'
import lang from 'element-ui/lib/locale/lang/en'
import locale from 'element-ui/lib/locale'

locale.use(lang)

Vue.use(Button)
Vue.use(Input)
Vue.use(Loading)
Vue.mixin({
  methods: {
    $message: Message
  }
})
